export default [
    { boarder: [0, 0, 0, 1], fill: [233, 247, 227, 1] },
    { boarder: [0, 0, 0, 1], fill: [182, 227, 172, 1] },
    { boarder: [0, 0, 0, 1], fill: [123, 200, 124, 1] },
    { boarder: [0, 0, 0, 1], fill: [42, 146, 74, 1] },
    { boarder: [0, 0, 0, 1], fill: [0, 68, 27, 1] }
    ];